module.exports = __webpack_public_path__ + "static/media/cart-item.e131509d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart-item.jpg
// module id = 1110
// module chunks = 33